export default function Footer() {
  const services = [
    'Vehicle Window Tinting',
    'Custom Vehicle Wraps',
    'Residential Window Films',
    'Commercial Fleet Branding',
    'Storefront Signage',
    'Brand Identity Design'
  ];

  const quickLinks = [
    'About Us',
    'Our Services',
    'Portfolio',
    'Testimonials',
    'Get Quote',
    'Contact'
  ];

  return (
    <footer className="bg-gray-800 border-t border-gray-700">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/b00b9d8e-2788-4194-a52d-d014a0e6f0e1.png"
              alt="BensonDesigns Logo"
              className="h-12 w-auto object-contain mb-6"
            />
            <p className="text-gray-300 mb-6 leading-relaxed">
              Your trusted partner for premium vehicle wraps, window tinting, and commercial signage solutions. 
              Quality craftsmanship with 15+ years of experience.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/bensondesigns" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-700 hover:bg-blue-600 rounded-full transition-colors cursor-pointer text-gray-300 hover:text-white"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a 
                href="https://www.instagram.com/bensondesigns" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-700 hover:bg-blue-600 rounded-full transition-colors cursor-pointer text-gray-300 hover:text-white"
              >
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a href="#" className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer text-sm">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href="#" className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer text-sm">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-6">Get In Touch</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-1 text-blue-400">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                <div>
                  <p className="text-gray-300 text-sm">
                    242 McTaggart Estates Lane<br />
                    Ridgeley, WV 26753
                  </p>
                </div>
              </div>
              
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3 text-blue-400">
                  <i className="ri-phone-line text-sm"></i>
                </div>
                <a href="tel:+12407272803" className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer text-sm">
                  240.727.2803
                </a>
              </div>
              
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3 text-blue-400">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <a href="mailto:info@thebensondesigns.com" className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer text-sm">
                  info@thebensondesigns.com
                </a>
              </div>
              
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3 text-blue-400">
                  <i className="ri-time-line text-sm"></i>
                </div>
                <div className="text-gray-300 text-sm">
                  <p>By Appointment Only</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 Your Company Name. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer text-sm">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-blue-400 transition-colors cursor-pointer text-sm">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
